import { Card, Col } from "reactstrap";
import { HoverRowsTitle } from "../../../../../constants";
import { HoverAbleRowsSubTitle, HoverRowsBody, HoverRowsHeader } from "../../../../../data/formsAndTable/tables/reactstrapTables/BasicTables";
import CommonTable from "./common/CommonTable";
import CommonCardHeader from "../../../../../coreComponents/CommonCardHeader";

const HoverableRows = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={HoverRowsTitle} span={HoverAbleRowsSubTitle} headClass="pb-20" tag />
        <div className="table-responsive signal-table custom-scrollbar">
          <CommonTable headData={HoverRowsHeader} hover={true}>
            {HoverRowsBody.map((data) => (
              <tr key={data.id}>
                <th scope="row">{data.id}</th>
                <td className="d-flex align-items-center">
                  {data.icon}
                  <span className={`font-${data.color}`}>{data.status}</span>
                </td>
                <td>{data.signalName}</td>
                <td>{data.security}</td>
                <td>{data.stage}</td>
                <td>{data.schedule}</td>
                <td>{data.teamLead}</td>
              </tr>
            ))}
          </CommonTable>
        </div>
      </Card>
    </Col>
  );
};
export default HoverableRows;
